// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__3Rd9I","inputText":"TextInput_inputText__3PIUf","error":"TextInput_error__16nsV"};